import styled from "styled-components";

interface IConsolePageDropDownContainerProps {
  show: boolean;
}

export const ConsolePageDropDownTriggerElementContainer = styled.div`
  display: flex;
  gap: 1rem;

  :hover:not(:disabled) {
    cursor: pointer;
  }

  svg path {
    color: ${({ theme }) => theme.console.pageTitleColor};
  }
`;

export const ConsolePageDropDownContent = styled.div`
  position: relative;
  transition: all 0.2s ease-in-out;
`;

export const ConsolePageDropDownContainer = styled.div<IConsolePageDropDownContainerProps>`
  .console-page-dropdown-arrow {
    transition: all 0.2s;
  }

  ${ConsolePageDropDownContent} {
    margin-top: ${({ show }) => (show ? "1rem" : "0")};
    pointer-events: ${({ show }) => (show ? "all" : "none")};
    opacity: ${({ show }) => (show ? "1" : "0")};
    z-index: ${({ show }) => (show ? "1" : "-1")};
    max-height: ${({ show }) => (show ? "" : "0")};
  }

  .console-page-dropdown-arrow {
    rotate: ${({ show }) => (show ? "0" : "180deg")};
  }
`;
